import React from "react";
import {TravelQuotation} from "../model/quotation";
import {TravelQuotationPackage} from "../model/quoationPackage";
import {ProductType} from "../api/model/common";


export interface ITravelQuotationContext {
    quotation: TravelQuotation;
    type: ProductType,
    setQuotation: (value: any) => void;
    packages: TravelQuotationPackage[];
    setPackages: (value: TravelQuotationPackage[]) => void;
    agree1Checkbox: boolean,
    setAgree1Checkbox: (value: boolean) => void;
    agreeInformCheckbox: boolean,
    setAgreeInformCheckbox: (value: boolean) => void;
    currentStep: string | null
    setCurrentStep: (value: string | null) => void;
    tariffied: boolean;
    setTariffied: (value: boolean) => void;
    payerIsPersonCheckbox: boolean
    setIsPayerIsPersonCheckbox: (value: boolean) => void;
    tab: string,
    setOpenErrorMessageDialog: (value:boolean) => void,
    setTab: (value:string) => void,
    foundPrimaryInsured: any,
    setFoundPrimaryInsured: (value:any) => void,
    isQuotationEditable: boolean;
    setIsQuotationEditable: (isQuotationEditable: boolean) => void;
}

export const TravelQuotationContext = React.createContext<ITravelQuotationContext>({
    quotation: null,
    type: ProductType.TRAVEL,
    setQuotation: () => {},
    packages: null,
    setPackages: () => {},
    agree1Checkbox: false,
    setAgree1Checkbox: () => {},
    agreeInformCheckbox: false,
    setAgreeInformCheckbox: () => {},
    currentStep: null,
    setCurrentStep: () => {},
    tariffied: false,
    setTariffied: () => {},
    payerIsPersonCheckbox: true,
    setIsPayerIsPersonCheckbox: () => {},
    tab: null,
    setOpenErrorMessageDialog: () => {},
    setTab: () => {},
    foundPrimaryInsured: null,
    setFoundPrimaryInsured: () => {},
    isQuotationEditable: null,
    setIsQuotationEditable: () => {}
});
